import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import {setError} from '../../HttpsConfigurationPage.actions'
import httpsConfigurationApi from '../../HttpsConfigurationPage.api'
import {usePortConfiguration} from '../../PortConfiguration/PortConfiguration'

import UploadButton from './UploadButton/UploadButton'

import styles from './CertificateUploadForm.css'

import {useAppDispatch} from 'src/hooks/react-redux'

function CertificateUploadForm() {
  const [certificateFile, setCertificateFile] = React.useState<File>()
  const [keyFile, setKeyFile] = React.useState<File>()

  const {data: defaultPort, isLoading: isDefaultPortLoading} =
    httpsConfigurationApi.endpoints.getDefaultHttpsPort.useQuery()

  const {validate, PortConfiguration, portConfigurationProps} = usePortConfiguration(
    defaultPort ?? '',
  )
  const {value: port} = portConfigurationProps

  const [upload, {isLoading: isUploading}] =
    httpsConfigurationApi.endpoints.uploadCertificate.useMutation()

  const dispatch = useAppDispatch()

  const handleSubmit = React.useCallback(
    (e: React.FormEvent) => {
      e.preventDefault()
      dispatch(setError(null))

      if (certificateFile != null && keyFile != null && validate()) {
        upload({certificateFile, keyFile, port})
        ;(document.activeElement as HTMLElement)?.blur()
      }
    },
    [dispatch, upload, validate, certificateFile, keyFile, port],
  )

  return (
    <form className={styles.uploadForm} onSubmit={handleSubmit}>
      <div>
        <UploadButton
          accept={'.pem, .crt, .cer'}
          uploadDescription={'Certificate: '}
          onFileUpload={setCertificateFile}
        >
          {'Upload certificate...'}
        </UploadButton>
      </div>
      <div>
        <UploadButton
          accept={'.pem, .key, .p8'}
          uploadDescription={'Key: '}
          onFileUpload={setKeyFile}
        >
          {'Upload key...'}
        </UploadButton>
      </div>
      <PortConfiguration
        className={styles.portConfig}
        {...portConfigurationProps}
        isLoading={isDefaultPortLoading}
      />
      <div>
        <Button
          type={'submit'}
          loader={isUploading}
          disabled={isDefaultPortLoading || certificateFile == null || keyFile == null}
          primary
        >
          {'Apply files'}
        </Button>
      </div>
    </form>
  )
}

export default CertificateUploadForm
